<script lang="ts">
  /* The body of one block's guide — «что это · как работает · что нужно
     сделать · частые вопросы» — rendered from the `lib/guides` registry.
     Used inside SectionGuide's panel and by Settings → «Как работает
     система», so the two are the same text by construction. */
  import { _ } from "svelte-i18n";
  import { guideById, range, type GuideId } from "$lib/guides";

  let { id }: { id: GuideId } = $props();
  const guide = $derived(guideById(id));
</script>

<div class="guide-body">
  <p class="guide-what">{$_(`guide.${id}.what`)}</p>

  <h4 class="guide-h">{$_("guide.how")}</h4>
  <ul class="guide-list">
    {#each range(guide.how) as n}
      <li>{$_(`guide.${id}.how.${n}`)}</li>
    {/each}
  </ul>

  <h4 class="guide-h">{$_("guide.todo")}</h4>
  <ol class="guide-steps">
    {#each range(guide.todo) as n}
      <li><span class="step-num">{n}</span><span>{$_(`guide.${id}.todo.${n}`)}</span></li>
    {/each}
  </ol>

  {#if guide.faq > 0}
    <h4 class="guide-h">{$_("guide.faq")}</h4>
    <div class="guide-faq">
      {#each range(guide.faq) as n}
        <div class="faq-item">
          <div class="faq-q">{$_(`guide.${id}.faq.${n}.q`)}</div>
          <div class="faq-a">{$_(`guide.${id}.faq.${n}.a`)}</div>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .guide-body { display: flex; flex-direction: column; gap: 10px; }
  .guide-what { margin: 0; font-size: 14px; color: var(--color-surface-darker); line-height: 1.5; }
  .guide-h { margin: 8px 0 0; font-size: 11px; font-weight: 700; letter-spacing: 0.07em; text-transform: uppercase; color: var(--color-text-muted); }
  .guide-list { margin: 0; padding-left: 18px; display: flex; flex-direction: column; gap: 6px; font-size: 13.5px; line-height: 1.5; color: #444; }
  .guide-steps { margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: 8px; }
  .guide-steps li { display: flex; align-items: flex-start; gap: 10px; font-size: 13.5px; line-height: 1.5; color: #444; }
  .step-num { flex-shrink: 0; width: 22px; height: 22px; border-radius: 50%; background: var(--color-primary); color: #fff; font-size: 12px; font-weight: 700; display: flex; align-items: center; justify-content: center; margin-top: 1px; }
  .guide-faq { display: flex; flex-direction: column; gap: 8px; }
  .faq-item { background: var(--color-bg); border-radius: 8px; padding: 9px 12px; font-size: 13px; line-height: 1.45; }
  .faq-q { font-style: italic; color: var(--color-text-muted); }
  .faq-a { color: var(--color-surface-darker); margin-top: 2px; }
</style>
